import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const [error, setError] = useState("");

  useEffect(() => {
    const hash = location.hash || "";
    const params = new URLSearchParams(hash.startsWith("#") ? hash.slice(1) : hash);
    const sessionId = params.get("session_id");
    if (!sessionId) { navigate("/login"); return; }
    let cancelled = false;
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        if (!cancelled) {
          setUser(data.user);
          navigate("/dashboard", { replace: true });
        }
      } catch (e) {
        setError("Could not complete sign-in. Please try again.");
        setTimeout(() => navigate("/login"), 2000);
      }
    })();
    return () => { cancelled = true; };
  }, [location, navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-brand-bg">
      <div className="text-center">
        <div className="h-10 w-10 mx-auto rounded-full border-2 border-brand-gold border-t-transparent animate-spin" />
        <p className="mt-4 text-brand-inkLight text-sm">{error || "Signing you in..."}</p>
      </div>
    </div>
  );
}
